import Cookies from "js-cookie";
import _ from 'lodash'
const currentUserEmail = Cookies.get('currentUserEmail')

export function getAllTutorialCookies(email) {
  if (!email)
    email = currentUserEmail
  const tutorial = Cookies.get('tutorial')
  if (tutorial && email) {
    const tutorialArr = JSON.parse(tutorial)
    const index = tutorialArr.findIndex(e => e.userEmail == email)
    return tutorialArr[index]
  }
}

export function getTutorialStep1() {
  return _.get(getAllTutorialCookies(), 'tutorialStep1') || undefined
}

export function getTutorialStep2() {
  return _.get(getAllTutorialCookies(), 'tutorialStep2') || undefined
}

export function isTutorialStep2Running() {
  const step2 = getTutorialStep2()
  if (step2)
    return step2
  return false
}

export function getTutorialStep3() {
  return _.get(getAllTutorialCookies(), 'tutorialStep3') || undefined
}

export function isTutorialStep3Running() {
  const step3 = getTutorialStep3()
  if (step3)
    return step3
  return false
}

export function setTutorialStep1(data) {
  const tutorial = Cookies.get('tutorial')
  const tutorialArr = JSON.parse(tutorial)
  const index = tutorialArr.findIndex(e => e.userEmail == currentUserEmail)
  const { tutorialStep1, ...other } = tutorialArr[index]
  tutorialArr[index] = { tutorialStep1: data, ...other }
  Cookies.set('tutorial', tutorialArr, { path: '/', sameSite: 'strict' })
}

export function setTutorialStep2(data) {
  const tutorial = Cookies.get('tutorial')
  const tutorialArr = JSON.parse(tutorial)
  const index = tutorialArr.findIndex(e => e.userEmail == currentUserEmail)
  const { tutorialStep2, ...other } = tutorialArr[index]
  tutorialArr[index] = { tutorialStep2: data, ...other }
  Cookies.set('tutorial', tutorialArr, { path: '/', sameSite: 'strict' })
}

export function setTutorialStep3(data) {
  const tutorial = Cookies.get('tutorial')
  const tutorialArr = JSON.parse(tutorial)
  const index = tutorialArr.findIndex(e => e.userEmail == currentUserEmail)
  const { tutorialStep3, ...other } = tutorialArr[index]
  tutorialArr[index] = { tutorialStep3: data, ...other }
  Cookies.set('tutorial', tutorialArr, { path: '/', sameSite: 'strict' })
}

export function removeTutorialThisUser() {
  const tutorial = Cookies.get('tutorial')
  const tutorialArr = JSON.parse(tutorial)
  const index = tutorialArr.findIndex(e => e.userEmail == currentUserEmail)
  tutorialArr.splice(index, 1)
  Cookies.set('tutorial', tutorialArr, { path: '/', sameSite: 'strict' })
}